'use client';

import { LinkList, StarRating } from '@petsmart-ui/sparky';

import { useScrollToSection } from '@libs/common-next';

import { useRatings } from './model';

import './Ratings.scss';

export const Ratings = () => {
    const { average, reviewsText } = useRatings();
    const scrollToSection = useScrollToSection();

    return (
        <StarRating
            className="product-ratings"
            behavior="wrap"
            onClick={() => scrollToSection('bv-reviews-section')}
            value={average}
            ratingAfter={
                <LinkList variant="lined" behavior="horizontal">
                    <LinkList.Item text={reviewsText} href="#bv-reviews-section" data-testid="product-ratings-link" />
                </LinkList>
            }
            data-testid="test-pdp-ratings"
        />
    );
};
